import { useTranslation } from "react-i18next";

import imageColor from "../img/products/include/color masterbatch.jpg";
import imageColor2 from "../img/products/include/Color-Masterbatch2.png";

import imageWhite from "../img/products/include/white masterbatch.jpg";
import imageWhite2 from "../img/products/White-Masterbatch2.png";

import imageBlack from "../img/products/include/Black-Masterbatch.jpg";
import imageBlack2 from "../img/products/Black-Masterbatch2.png";

import imageAdditive from "../img/products/include/antimicrobial.jpg";
import imageAdditive2 from "../img/products/newimages/Antimicrobial-Masterbatch2.png";

import imageUVStabilizer from "../img/products/include/UV Stabilizer Masterbatch.jpg";

import imageAntiblock from "../img/products/include/Anti-block Masterbatch.jpg";
import imageAntiblock2 from "../img/products/newimages/Anti-Block-Masterbatch2.png";

import imageProcessAids from "../img/products/include/Process Aids Masterbatch.jpg";
import imageAntiSlip from "../img/products/include/Anti-Slip Masterbatch.jpg";
import imageAntioxidant from "../img/products/include/Antioxidant Masterbatch.jpg";
import imageAntistatic from "../img/products/include/Antistatic Masterbatch.jpg";

import imageAntifog from "../img/products/include/Anti-fog Masterbatch 1.jpg";
import imageClarifier from "../img/products/include/Clarifier Masterbatch.jpg";
import imageImpactModifier from "../img/products/include/Impact modifier Masterbatch.jpg";
import imageFlameRetardant from "../img/products/include/Flame Retardant Masterbatch.jpg";

import imageOpticalBrightener from "../img/products/include/Optical brightener Masterbatch.jpg";
import imagePreColored from "../img/products/include/Pre-colored resin & Compounds Masterbatch.jpeg";
import imagePurging from "../img/products/include/Purging compound Masterbatch.jpg";

import imageDesiccant from "../img/products/include/Desiccant Masterbatch.jpg";
import imageDesiccant2 from "../img/products/newimages/Desiccant-Masterbatch2.jpeg";

import imageOxobiodegradable from "../img/products/include/Oxo-biodegradable Masterbatch.webp";
import imageBlowingAgent from "../img/products/newimages/Blowing-Agent-Masterbatch2.png";

import imageClingagent from "../img/products/include/Cling agent Masterbatch.avif";
import imageClingagent2 from "../img/products/newimages/Cling-Agent-Masterbatch2.png";

import CalciumCarbonate from "../img/products/natural-spa-cosmetics-rustic-wooden-table.jpg"
import CalciumCarbonate2 from "../img/products/Calcium-Carbonate-Masterbatch2.png"

export const ProductsData = () => {
  const { i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  return {
    masterbatch: [
      {
        id: "color",
        title: isArabic ? "ماستر باتش ملون" : "Color Masterbatch",
         thumbnail: imageColor2,
           innerImages: [
    imageColor,
    imageColor2 
  ],
        sections: [
          {
            body: isArabic
              ? `
<p>يُعدّ مظهر المنتج المصنّع طالما أنه يؤدي وظيفته الأساسية من أهم العوامل التي تحدد قابليته للتسويق والنجاح في السوق.</p>
<p>ومن بين جميع الجوانب البصرية، يُعتبر اللون العنصر الأكثر أهمية لدى العملاء، لأن بهتان اللون أو عدم ثباته وتناسقه يعطي انطباعًا مباشرًا عن ضعف الجودة.</p>
<p>وتساعد قياسات اللون على تحويل إدراك الإنسان للّون إلى قيم ومعايير موضوعية.</p>
<br />
<p>ويعتمد إدراك اللون على العناصر التالية:</p><br />
<ul>
  <li><strong>الدرجة اللونية / الكروما:</strong> مثل البنفسجي، الأزرق، الأخضر، الأحمر.</li>
  <li><strong>التشبّع / النقاء:</strong> قوة اللون وحدّته مقارنةً باللون الأبيض.</li>
  <li><strong>السطوع / الإضاءة :</strong> خاصية تجعل الجسم يبدو أكثر أو أقل سطوعًا، أو أكثر/أقل قدرة على تمرير الضوء.</li>
</ul>`
              : `
<p>The appearance of a manufactured product, provided it fulfills its main function, is one of its most important features for marketability.</p>
<p>Among all visual aspects, color is the most critical for customers. Faded or inconsistent colors signal poor quality.</p>
<p>Color measurement translates human perception into objective values. Color perception is based on:</p><br />
<ul>
  <li><strong>Hue/Chroma:</strong> Names like violet, blue, green, red.</li>
  <li><strong>Saturation/Purity:</strong> Intensity of color compared to white.</li>
  <li><strong>Brightness/Lightness:</strong> Attribute that makes an object appear more or less bright or light-transmitting.</li>
</ul>`,
          },
        ],
      },
      {
        id: "white",
        title: isArabic ? "ماستر باتش أبيض" : "White Masterbatch",
        thumbnail: imageWhite2,
        innerImages: [
          imageWhite,
          imageWhite2
        ],
        sections: [
          {
            body: isArabic
              ? `
<p>تم تصميم تركيزاتنا البيضاء المتقدمة (بنسبة تصل إلى 75% من ثاني أكسيد التيتانيوم TiO₂ والمستخدمة في بولي إيثيلين منخفض الكثافة الخطي) خصيصًا من أجل: </p><br />
<ul>
  <li>تحسين مقاومة الاصفرار/الاحمرار الناتج عن المركبات الفينولية</li>
  <li>تعزيز درجة البياض والثبات الحراري</li>
  <li>توفير عتامة عالية مع نسب تخفيف منخفضة</li>
</ul>
<br />
<p><strong>الاستخدامات:</strong> بثق الأفلام، الورق، الحقن، النفخ</p>`
              : `
<p>Our advanced white concentrates (up to 75% TiO₂, used in LLDPE) are specially designed to:</p><br />
<ul>
  <li>Improve resistance to phenolic yellowing/pinking.</li>
  <li>Enhance whiteness and thermal stability.</li>
  <li>Provide high opacity with low letdown ratios.</li>
</ul>
<p><strong>Applications:</strong> film extrusion, paper, injection, blow molding.</p>`,
          },
        ],
      },
      {
        id: "black",
        title: isArabic ? "ماستر باتش أسود" : "Black Masterbatch",
                thumbnail: imageBlack2,
        innerImages: [
          imageBlack,
          imageBlack2
        ],
        sections: [
          {
            body: isArabic
              ? `
<p>تغطي تركيزات الكربون الأسود لدينا نطاقًا واسعًا من الأصباغ، بدءًا من أحجام الجسيمات الكبيرة إلى الصغيرة، ومن اللون الأسود الحالك إلى البني.</p>
<p>ويمكن استخدامها في العديد من أنظمة البوليمرات مثل: ABS، وGPPS، وHIPS، وLDPE، وLLDPE، وHDPE، وبولي بروبلين متجانس PP، وبولي بروبلين مشترك Copolymer PP.</p><br />
<p><strong>الاستخدامات الشائعة:</strong>  الأكياس، الخلطات المركبة، الأنابيب، 
الألياف، والمنتجات المصنّعة بالقولبة بالحقن أو القولبة بالنفخ. </p><br />
<p><strong>القطاعات التي نخدمها:</strong> الزراعة، المنتجات الاستهلاكية، 
القطاع الصناعي، وقطاع التغليف والتعبئة.</p>`
              : `
<p>Our carbon black concentrates cover a wide pigment range, from large to small particle sizes, and from jet black to brown.</p>
<p>They can be used in various polymer systems such as ABS, GPPS, HIPS, LDPE, LLDPE, HDPE, homopolymer PP, and copolymer PP.</p><br />
<p><strong>Typical applications:</strong> bags, compounds, pipes, fibers, injection or blow molded products.</p><br />
<p><strong>Industries served:</strong> agriculture, consumer, industrial, and packaging.</p>`,
          },
        ],
      },
    ],

    additives: [
      {
        id: "antimicrobial",
        title: isArabic ? "ماستر باتش مضاد للميكروبات" : "Antimicrobial Masterbatch",
        thumbnail: imageAdditive2,
        innerImages: [
          imageAdditive,
          imageAdditive2
        ],
        sections: [
          {
            body: isArabic
              ? `
<p><strong>مركّزات مضادة للميكروبات</strong></p>
<p>هي إضافات خاصة يستخدمها مصنعو البلاستيك للتحكم في نمو الميكروبات على المنتجات البلاستيكية والمنسوجات. توفر هذه الإضافات ميزة تنافسية وطريقة اقتصادية لزيادة القيمة والأداء.</p>
<br />

<p><strong>المجالات التي توفر فيها المضادات الميكروبية الحماية:</strong></p>
<ul>
  <li>البلاستيك</li>
  <li>الأفلام البلاستيكية</li>
  <li>الأجزاء المصبوبة أو المشكلة بالقولبة</li>
  <li>طبقات العزل الكهربائي</li>
  <li>المواد اللاصقة</li>
  <li>الورق</li>
  <li>الدهان الرطب</li>
</ul>`
              : `
<p><strong>Antimicrobial Masterbatches</strong></p>
<p>Antimicrobial Masterbatches: These are special additives used by plastic manufacturers to control the growth of microbes on plastic products and textiles. They provide a competitive advantage and an economical means of increasing value and performance.</p>
<br />

<p><strong>Where antimicrobials provide protection:</strong></p>
<ul>
  <li>Plastics</li>
  <li>Films</li>
  <li>Fibers</li>
  <li>Moldings</li>
  <li>Electrical insulation coatings</li>
  <li>Adhesives</li>
  <li>Paper</li>
  <li>Wet paints</li>
</ul>
`,
          },
        ],
      },

      {
        id: "anti-block",
        title: isArabic ? "ماستر باتش مضاد للالتصاق" : "Anti-block Masterbatch",
                thumbnail: imageAntiblock2,
        innerImages: [
          imageAntiblock,
          imageAntiblock2
        ],
        sections: [
          {
            body: isArabic
              ? `
              <div dir="rtl" align="right">
<p >يواجه مصنعو الأفلام البلاستيكية باستمرار تحديات مثل الازدهار السطحي والتلاصق ، لذلك نقدم ماستر باتش يجمع بين إضافات الانزلاق  ومضاد الالتصاق  في منتج واحد. </p>
<br />
<p >وتشمل مجموعتنا عدة درجات مناسبة لمختلف عمليات التعبئة والتغليف، لتضمن الحصول على إضافة مبتكرة ومرنة تلبي عدة احتياجات في نفس الوقت.</p>
<br />
<p><strong>الفوائد:</strong> منع تلاصق الفيلم أثناء التصنيع وبعده، تقليل الاحتكاك على سطح الفيلم، تحسين كفاءة عملية الإنتاج ورفع الأداء</p>
<p><strong>البوليمرات المناسبة:</strong> البولي إيثيلين ، البولي بروبلين ،
 الأيونومرات.</p>
<p><strong>الخيارات المتاحة:</strong>  السيليكا الصناعية، الحجر الجيري، التلك. 
الاستخدامات: الأفلام، الصفائح، والتعبئة والتغليف.</p>
</div>`
              : `
<p>Film manufactures are continuously challenged by both blooming and blocking, we offer both slip and anti-block additives in one masterbatch.</p>
<br />
<p>Our range includes several grades suitable for different types of packaging processes, so you get an innovative, agile additive that meets several needs at once.</p>
<br />
<p><strong>Benefits:</strong> Preventing film blocking during and after processing,
Reduced surface friction,
Optimized production process and performance</p>
<p><strong>Polymers:</strong> PE, PP, Ionomers.</p>
<p><strong>Options:</strong> Synthetic Silica, Limestone, Talc.</p>
<p><strong>Applications:</strong> films, sheets, packaging.</p>`,
          },
        ],
      },

      {
        id: "process-aids",
        title: isArabic ? "ماستر باتش مساعدات التشغيل" : "Process Aids Masterbatch",
                        thumbnail: imageProcessAids,
        innerImages: [
          imageProcessAids
        ],
        sections: [
          {
            body: isArabic
              ? `
<p>تم تصميم ماستر باتش مساعدات المعالجة من شركة أكتيف 
بوليمرز خصيصًا لتحسين أداء الأفلام المنفوخة وغيرها من
 منتجات البثق من حيث الخواص البصرية والخواص الميكانيكية،
 مع المساهمة في خفض تكلفة الإنتاج. </p>
<br />
<p>أثناء عملية التصنيع، تتكوّن طبقة من الماستر باتش على جدران
 جهاز البثق (الإكسترودر) وقالب التشكيل (الداي)، مما يساعد على تقليل الضغط العكسي داخل الإكسترودر 
وتحسين انسيابية التشغيل. </p>
<br />
<p>ولتحقيق هذا الطلاء خلال وقت مناسب، يتم عادةً إضافة ماستر باتش مساعدات المعالجة بنسبة 1%  حتى
 تظهر النتائج والفوائد المطلوبة. </p>
<br />
<p><strong>التطبيقات:</strong> الأفلام، الأنابيب، المواسير، والقولبة بالحقن.</p>`
              : `
<p>Active Polymer processing aids masterbatches are specially engineered for improving the performance of blown films & other extrusion products in terms of optical properties, mechanical properties with reductions in the production cost.</p>
<br />
<p>During processing the masterbatches gets coated on the walls of the extruder and die. </p>
<br />
<p>This reduces the extruder backpressure to decrease. To achieve the coating in a reasonable time the process aid masterbatch is typically added at 1% until the beneficial effects are seen.</p>
<p><strong>Applications:</strong> films, pipes, tubes, injection molding.</p>`,
          },
        ],
      },

      {
        id: "antioxidant",
        title: isArabic ? "ماستر باتش مضاد للأكسدة" : "Antioxidant Masterbatch",
        thumbnail: imageAntioxidant,
        innerImages: [
          imageAntioxidant
        ],
        sections: [
          {
            image: imageAntioxidant,
            body: isArabic
              ? `
<p>تستخدم ماستر باتش مضادات الأكسدة من شركة آكتيف بوليمرز على نطاق واسع
 في صناعة البلاستيك لحماية البوليمرات من التحلل والتدهور عند درجات الحرارة العالية. </p>
<br />
<p>تمت صياغة هذه الماستر باتش اعتمادًا على مضادات أكسدة فينولية معيقة فراغيًا، 
وموزعة بشكل جيد داخل حامل من البولي أوليفين، مما يجعلها فعّالة في حماية 
المنتج النهائي 
والحفاظ على اللمعان والخواص الميكانيكية لفترة أطول.  </p>

<br />
<p><strong>الاستخدامات:</strong> الأشرطة، الألياف، المنسوجات الجيوتقنية،
 الأفلام، والقولبة بالحقن. </p>`
              : `
<p>Active Polymer Antioxidant masterbatches has wide application in the plastic industry for protecting the polymers from degradation at high temperature range. </p>
<br />
<p>Formulated on the basis of sterically hindered phenolic antioxidants that are properly dispersed in poly-olefin carrier, these masterbatches are responsible for protecting and retaining the gloss and mechanical properties of the end product.</p>
<br />
<p><strong>Applications:</strong> tapes, fibers, geotextiles, films, injection molding.</p>`,
          },
        ],
      },

      {
        id: "antistatic",
        title: isArabic ? "ماستر باتش مضاد للكهرباء الساكنة" : "Antistatic Masterbatch",
               thumbnail: imageAntistatic,
        innerImages: [
          imageAntistatic
        ],
        sections: [
          {
            image: imageAntistatic,
            body: isArabic
              ? `
<p>يعتمد هذا المستخلص المركّز على مواد كيميائية من أساس الستيرات والأمينات. يُستخدم بشكل أساسي في الأفلام والأجزاء المصبوبة المصنوعة من بولي إيثيلين وبولي بروبيلين.</p><br />
<p>يُوفّر تأثير التشحيم أثناء التشكيل أو البثق، مما يساهم في الحصول على سطح ناعم ولامع للمنتج النهائي. </p><br />
<p>كما يُستخدم كـ عامل مضاد للكهرباء الساكنة لتقليل المقاومة الكهربائية على سطح الأفلام والمنتجات المصبوبة.</p><br />
<p>يساهم أيضًا في توزيع منتظم لحجم الخلايا في الرغوات الموسعة من البولي إيثيلين (EPE).</p><br />
<p><strong>التطبيقات:</strong> أفلام ، التغليف ، الأرضيات ، الألياف ، الأجزاء المصبوبة.</p>`
              : `
<p>This Masterbatch is based on stearate and amine bases chemicals. It is mainly used in films and moldings made of PE and PP.</p><br />
<p>It gives lubricating effect during molding or extrusion contributing to a smooth, shiny surface on the product produced.</p><br />
<p>It is also used as an antistatic agent to reduce the electrical resistance on the surface of films and molded products.</p><br />
<p>It also gives uniform cell size distribution in expanded polyethylene (EPE) foams. </p><br />
<p><strong>Applications:</strong> packaging films, flooring, fibers, molding.</p>`,
          },
        ],
      },

      {
        id: "clarifier",
        title: isArabic ? "ماستر باتش شفاف" : "Clarifier Masterbatch",
                       thumbnail: imageClarifier,
        innerImages: [
          imageClarifier
        ],
        sections: [
          {
            body: isArabic
              ? `
<p>الخصائص الرئيسية لمُوضّح البوليمر النشط</p>
<ul>
  <li>تحسّن زمن الدورة، وتزيد درجة الحرارة المحددة للتعريف، ومعامل الانحناء، والصلابة، وقوة الصدمة في البولي بروبيلين, كما أنها تعزز عملية التبلور بشكل أسرع.</li>
  <li>تستخدم وحدات التصفية الرئيسية لأفلام PP المستخدمة في التغليف، وحاويات الطعام والتخزين PP، والزجاجات المصبوبة بالنفخ، وأيضا الأجزاء المصبوبة بالحقن.</li>
  <li> يحسن وضوح ال  PP، يقلل الضباب، يحسن مدة الدورة ويزيد من الصلابة والمتانة.</li>
</ul><br />
<p><strong>التطبيقات:</strong> أفلام التغليف، الحاويات، الزجاجات.</p>`
              : `
<p>Active Polymer Clarifier Masterbatches improves cycle time, higher definition temperature, flexural modulus, stiffness & impact strength in PP. It also promotes faster crystallization. </p><br />

<p>Clarifier Masterbatches are used for PP films used in packaging, PP Food & storage Containers, blow molded bottles & also Injection molded parts. It also improves clarity in PP, Reduces haze, Improves cycle time & increases stiffness and durability.</p><br />

<p><strong>Applications:</strong> packaging films, containers, bottles.</p>`,
          },
        ],
      },

      {
        id: "impact-modifier",
        title: isArabic ? "ماستر باتش معدل الصدمات" : "Impact Modifier Masterbatch",
                               thumbnail: imageImpactModifier,
        innerImages: [
          imageImpactModifier
        ],
        sections: [
          {
            body: isArabic
              ? `
<p>يتم إضافة معدّلات الصدمات إلى البوليمرات لتعزيز المتانة والتحمل، والخصائص المثلى للقوة، ومقاومة الاشتعال في المنتجات النهائية.</p><br />
<p>تعمل مستخلصات معدل الصدمات من آكتيف بوليمرز على تحسين: مقاومة الشقوق الناتجة عن الإجهاد ومقاومة الصدمات والمرونة وتحسين المظهر الجمالي للمنتج،مما يجعل منتجاتك تتميّز في الأسواق التنافسية.</p><br />

<p><strong>التطبيقات:</strong> الكابلات، مواد البناء، البوليمرات الصلبة ،
الأكياس.</p>`
              : `
<p>These impact modifiers are added in polymers to enhance toughness & endurance, optimal and strength properties and flammability of end products. </p><br />
<p>Active polymers impact modifier masterbatch to improve stress crack resistance, impact resistance, flexibility and aesthetic enhancements making your products stand out in the competitive markets.</p><br />
<p><strong>Applications:</strong> cables, construction, rigid polymers, bags.</p>`,
          },
        ],
      },

      {
        id: "pre-colored",
        title: isArabic ? "ماستر باتش مسبق التلوين" : "Pre-colored Resin & Compounds",
                                      thumbnail: imagePreColored,
        innerImages: [
          imagePreColored
        ],
        sections: [
          {
            body: isArabic
              ? `
<p>توفر المركبات الراتنجية الملونة مسبقًا ألوانًا دقيقة ومتناسقة عبر أنواع متعددة من البوليمرات.</p>
<p><strong>التطبيقات:</strong> الأثاث،الأجهزة المنزلية ،
السيارات،
 التغليف.</p>`
              : `
<p>Provides precise and consistent colors across multiple polymers.</p>
<p><strong>Applications:</strong> furniture, appliances, automotive, packaging.</p>`,
          },
        ],
      },

      {
        id: "purging-compound",
        title: isArabic ? "ماستر باتش تنظيف" : "Purging Compound Masterbatch",
      thumbnail: imagePurging,
        innerImages: [
          imagePurging
        ],
        sections: [
          {
            body: isArabic
              ? `
<p>يقوم مركب التنظيف بتنظيف معدات البثق والتشكيل أثناء تغييرات المواد أو الألوان.</p>
<p><strong>الفوائد:</strong> يقلل من وقت التوقف عن العمل، يحسّن الإنتاجية، يقضي على التلوث أو البقايا داخل المعدات.</p>`
              : `
<p>Cleans extrusion and molding equipment during material or color changes.</p>
<p><strong>Benefits:</strong> reduces downtime, improves productivity, eliminates contamination.</p>`,
          },
        ],
      },

      {
        id: "desiccant",
        title: isArabic ? "مستخلص مجفف الرطوبة" : "Desiccant Masterbatch",
              thumbnail: imageDesiccant2,
        innerImages: [
          imageDesiccant,imageDesiccant2
        ],
        sections: [
          {
            image: imageDesiccant,
            body: isArabic
              ? `
<p>يُعتبر مستخلص مجفف الرطوبة ثورة في تحسين جودة المنتجات وكفاءة عمليات التصنيع. تم تصميم هذا المستخلص خصيصًا لإزالة الرطوبة أثناء معالجة البلاستيك، مما يحسّن بشكل كبير جودة المنتجات البلاستيكية.</p><br />
<p>سواء كان ذلك في عمليات الحقن عالية الجودة أو بثق الأفلام البلاستيكية، أصبح فهم فوائد مستخلص مجفف الرطوبة أمرًا أساسيًا للمصنعين.</p>`
              : `
<p>Desiccant Masterbatch is a game-changer in enhancing product quality and efficiency in manufacturing. Designed specifically to remove moisture during plastic processing, this additive significantly improves the quality of plastic products.</p><br />
<p>Whether it’s for high-quality injection molding or film extrusion, understanding the benefits of desiccant masterbatch has become essential for manufacturers.</p>
`,
          },
        ],
      },

      {
        id: "blowing-agent",
        title: isArabic ? "ماستر باتش عامل نفخ" : "Blowing Agent Masterbatch",
          thumbnail: imageBlowingAgent,
        innerImages: [
          imageBlowingAgent
        ],
        sections: [
          {
            body: isArabic
              ? `
              <p><strong>أخف وزنًا، أكثر ذكاءً، وأداء مصمم بدقة</strong> </p><br />
<p>في عالم صناعة البلاستيك التنافسي، يمكن أن يقدم مستخلص عامل النفخ فوائد متعددة للمصنعين وعملائهم.</p><br />

     <p><strong>تشمل هذه الفوائد:</strong> </p>
<ul>
  <li>توفير الوزن في المكونات المنتَجة</li>
  <li>توفير التكاليف نتيجة تقليل كمية البوليمر المطلوبة لإنتاج الدفعة</li>
  <li> تحسين زمن الدورة في التصنيع، مما يؤدي إلى توفير الوقت والطاقة للمصنع</li>
</ul>`
              : `
 <p><strong>Lighter, smarter & precision-engineered performance:</strong> </p><br />
<p>In the competitive world of plastic manufacturing, a blowing agent masterbatch can offer multiple benefits to manufacturer and their customers.</p><br />
<pThese include weight savings in the producer component and cost savings resulting from a reduction in the amount of polymer required for the production run. Improved cycle times can be a further benefit for the manufacturer, delivering time and energy savings.</p>
`,
          },
        ],
      },

      {
        id: "cling-agent",
        title: isArabic ? "مستخلص عامل الالتصاق" : "Cling Agent Masterbatch",
                thumbnail: imageClingagent2,
        innerImages: [
          imageClingagent,imageClingagent2
        ],
        sections: [
          {
            image: imageClingagent,
            body: isArabic
              ? `
<p>مستخلص الالتصاق (PIB) بولى إيزو بيوتين أو مركب
(PIB )هو مادة حبيبية سهلة الاستخدام تُستخدم في إنتاج الأفلام المرنة ذاتية الالتصاق المصنوعة من البولي إيثيلين الخطي منخفض الكثافة أو البولي إيثيلين منخفض الكثافة.</p><br />
<p>يتكوّن هذا المركب من (PIB) بولي إيثيلين مقاوم للانزلاق، وعامل توزيع، مما يسهم في تحسين قدرة الفيلم على الالتصاق والتمدد.</p><br />
<p>يُعد هذا المركب مناسبًا لمختلف احتياجات التغليف واللف في خطوط إنتاج الأفلام المنفوخة وكذلك الأفلام المصبوبة.</p>`
              : `
<p>PIB (Poly Iso Butene) Cling Masterbatch or PIB Compound is a convenient-to-use granular material used in the production of self-adhesive stretch cling films made from LLDPE or LDPE.</p><br />
<p>Its composition of PIB, Non-Slip Polyethylene, and a Dispersing Agent contributes to the film’s cling and stretching capabilities, making it suitable for various packaging and wrapping needs in both Blown Film and Cast Film Line production processes.</p><br />
`,
          },
        ],
      },
    ],

        minerals: [
      {
        id: "calcium-carbonate",
        title: isArabic ? "كربونات الكالسيوم" : "CALCIUM CARBONATE",
                        thumbnail: CalciumCarbonate2,
        innerImages: [
          CalciumCarbonate,CalciumCarbonate2
        ],
        sections: [
          {
 body: isArabic
              ? `
<h3>كربونات الكالسيوم في صناعة البلاستيك</h3>
<p>تعد كربونات الكالسيوم مادة شائعة الاستخدام في صناعة البلاستيك بفضل خصائصها الفيزيائية والكيميائية المميزة.</p>

<h4>الخصائص الفيزيائية:</h4>
<ul>
  <li><strong>المظهر:</strong> مسحوق أبيض عديم الرائحة والطعم، يعطي لمعانًا نهائيًا دون الحاجة لمبيضات إضافية.</li>
  <li><strong>الصلابة:</strong> الصلابة العالية تجعلها مادة مالئة فعّالة لتقوية البلاستيك.</li>
  <li><strong>الذوبان:</strong> مادة غير قابلة للذوبان مما يحافظ على استقرار المنتج.</li>
</ul>

<h4>الخصائص الكيميائية:</h4>
<ul>
  <li><strong>التفاعل:</strong> نشطة في تحييد الأحماض وتفيد في العمليات الكيميائية.</li>
  <li><strong>التحلل:</strong> تتحلل عند درجات حرارة أعلى من 800 °م.</li>
  <li><strong>التوافق:</strong> لا تغير الخصائص الكيميائية عند مزجها مع جميع أنواع البلاستيك.</li>
</ul>

<h4>فوائد استخدامها في البلاستيك:</h4>
<ol>
  <li><strong>الكفاءة من حيث التكلفة:</strong> تقلل تكلفة الإنتاج باستبدال جزئي للراتنجات البوليمرية.</li>
  <li><strong>تحسين الخصائص الميكانيكية:</strong> تزيد الصلابة ومقاومة الشد والكسر.</li>
  <li><strong>تحسين قابلية المعالجة:</strong> تزيد من تدفق المواد وسهولة المعالجة.</li>
  <li><strong>التعددية:</strong> متوافقة مع العديد من البوليمرات مثل PVC، PP، PE.</li>
</ol>

<h4>التطبيقات:</h4>
<ul>
  <li><strong>ألواح السقف والأبواب البلاستيكية:</strong> تحسين التشطيب واللمعان.</li>
  <li><strong>أنابيب البلاستيك:</strong> تعزيز الصلابة ومقاومة الصدمات.</li>
  <li><strong>خطوط النقل:</strong> تقليل التكاليف وتحسين مقاومة الحريق.</li>
  <li><strong>الأغشية:</strong> زيادة المتانة وتحسين المقاومة الكيميائية.</li>
</ul>


<h4>الاستدامة والأثر البيئي:</h4>
<ul>
  <li>تقليل غازات الدفيئة بنسبة تصل إلى 23%.</li>
  <li>توفير الطاقة بنسبة 15-20%.</li>
  <li>خفض استخدام النفط الخام والغاز الطبيعي.</li>
  <li>تقليل انبعاثات NOx وSOx.</li>
</ul>
`
              : `
<h3>Calcium Carbonate: Why is it Used in Plastics?</h3>
<p>Calcium carbonate is widely used in the plastic industry thanks to its favorable physical and chemical properties.</p>

<h4>Physical Properties:</h4>
<ul>
  <li><strong>Appearance:</strong> White, odorless, tasteless powder providing brilliant whiteness without extra additives.</li>
  <li><strong>Hardness:</strong> High hardness makes it an effective strengthening filler.</li>
  <li><strong>Solubility:</strong> Insoluble, maintaining product stability in plastics.</li>
</ul>

<h4>Chemical Properties:</h4>
<ul>
  <li><strong>Reactivity:</strong> Reactive in neutralizing acids, useful in chemical processes.</li>
  <li><strong>Decomposition:</strong> Decomposes at >800 °C.</li>
  <li><strong>Compatibility:</strong> Blends with all plastics without altering chemical properties.</li>
</ul>

<h4>Benefits in Plastics:</h4>
<ol>
  <li><strong>Cost efficiency:</strong> Reduces resin cost while maintaining quality.</li>
  <li><strong>Enhanced mechanical properties:</strong> Improves tensile strength and stiffness.</li>
  <li><strong>Improved processability:</strong> Better flow, mold filling, and higher productivity.</li>
  <li><strong>Versatility:</strong> Compatible with PVC, PP, PE, etc.</li>
</ol>

<h4>Applications:</h4>
<ul>
  <li><strong>Ceiling panels & plastic doors:</strong> Enhances gloss and finish.</li>
  <li><strong>Plastic pipes:</strong> Improves hardness, smoothness, and impact resistance.</li>
  <li><strong>Transmission lines:</strong> Reduces costs, improves fire resistance.</li>
  <li><strong>Films:</strong> Enhances durability and chemical resistance.</li>
</ul>



<h4>Sustainability & Environmental Impact:</h4>
<ul>
  <li>Up to 23% greenhouse gas reduction.</li>
  <li>15-20% energy savings.</li>
  <li>Reduced crude oil and natural gas consumption.</li>
  <li>Lower NOx and SOx emissions.</li>
</ul>
`,
          },
        ],
      },
    ],
  };
};
